export const environmentTabs = [
  { label: "Overview", slug: "" },
  { label: "Builds", slug: "builds" },
  { label: "Deploys", slug: "deploys" },
  { label: "Resources", slug: "resources" },
  { label: "Namespaces", slug: "namespaces" },
  { label: "App Imports", slug: "app_imports" },
  {
    label: "Settings",
    slug: "settings",
    path: "configuration",
  },
] as const;

export type EnvironmentTabItem = (typeof environmentTabs)[number]["slug"];
